<div class="notifications-management-wrapper">
  <h2>{{ translationService.translate('notificationsText') }}</h2>
  @for (notificationType of notificationTypes; track notificationType.resourceType) {
  <div class="notification-setting-row">
    <div class="notification-copy">
      <h3>{{ translationService.translate(notificationType.titleTranslationKey) }}</h3>
      <p>{{ translationService.translate(notificationType.descriptionTranslationKey) }}</p>
    </div>

    <div class="notification-toggle-wrap">
      <span class="toggle-label">{{
        translationService.translate(isNotificationTypeEnabled(notificationType.resourceType) ? 'activeText' : 'inactiveText')
      }}</span>
      <mat-slide-toggle
        [id]="notificationType.resourceType.toLowerCase() + '-notifications-toggle'"
        [checked]="isNotificationTypeEnabled(notificationType.resourceType)"
        [disabled]="saving"
        (change)="toggleNotificationType(notificationType.resourceType)"
      ></mat-slide-toggle>
    </div>
  </div>
  }
  <app-notification-banner-admin></app-notification-banner-admin>
</div>
